import { RouteItem } from '@eastcoal/router/types/route'

import { TRADE_LOG_PAGE_UUID } from './constants/uuid'

export const tradeLogRoute: RouteItem = {
  title: '交易日志',
  uuid: TRADE_LOG_PAGE_UUID,
  path: '/tradeLog',
  Component: () => import('./index')
}
